import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "es-modal-footer w-full" }
const _hoisted_2 = { class: "row es-modal-footer-content w-full btn-right gap-08" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "row gap-04"
}
const _hoisted_5 = { key: 2 }

import { ItemButtonGroup } from "@/models/share.model";
import { useI18n } from "vue-i18n";
import esButton from '@/components/esButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'esModalFooter',
  props: {
    confirmLabel: { default: 'action.confirm' },
    cancelLabel: { default: 'action.cancel' },
    displayCancel: { type: Boolean, default: true },
    confirmDisabled: { type: Boolean, default: false },
    itemButtonGroup: {},
    confirmModalMethod: {}
  },
  emits: ["modal-cancel"],
  setup(__props: any, { emit: __emit }) {



const { t } = useI18n();
const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _directive_one_click = _resolveDirective("one-click")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.displayCancel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(esButton, {
              label: _unref(t)(_ctx.cancelLabel),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('modal-cancel'))),
              "is-primary": false
            }, null, 8, ["label"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.itemButtonGroup)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemButtonGroup, (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _withDirectives(_createVNode(esButton, {
                  label: _unref(t)(`action.${item.codeAction}`),
                  "icon-content-button": item,
                  "is-primary": true,
                  disabled: _ctx.confirmDisabled,
                  iconStyles: "img-white"
                }, null, 8, ["label", "icon-content-button", "disabled"]), [
                  [_directive_one_click, item.method ? () => item.method() : undefined]
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _withDirectives(_createVNode(esButton, {
              disabled: _ctx.confirmDisabled,
              label: _unref(t)(_ctx.confirmLabel),
              "is-primary": true
            }, null, 8, ["disabled", "label"]), [
              [_directive_one_click, () => _ctx.confirmModalMethod()]
            ])
          ]))
    ])
  ]))
}
}

})